// ScrollHintのCSSとJSをロードする
var scrollHintStylesheet = document.createElement('link');
scrollHintStylesheet.rel = 'stylesheet';
scrollHintStylesheet.href = 'https://unpkg.com/scroll-hint@latest/css/scroll-hint.css';
document.head.appendChild(scrollHintStylesheet);

var scrollHintScript = document.createElement('script');
scrollHintScript.src = 'https://unpkg.com/scroll-hint@latest/js/scroll-hint.min.js';
scrollHintScript.onload = initScrollHint;
document.head.appendChild(scrollHintScript);

function initScrollHint() {
  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-white',
    suggestiveShadow: true,
    i18n: {
      scrollable: "スクロールできます"
    }
  });
}